const COMMITTEE_ROUTE = '/committee'
const TERM_ROUTE = '/term/list'

export { COMMITTEE_ROUTE, TERM_ROUTE }
